import { render, staticRenderFns } from "./paper-desc.vue?vue&type=template&id=6ffa431e"
import script from "./paper-desc.vue?vue&type=script&lang=js"
export * from "./paper-desc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports